import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.VIDEO_SDK_UC],
  data() {
    return {
      title: this.$t('billing.video_sdk_uc.title'),
      subtitle: this.$t('billing.video_sdk_uc.subtitle_new'),
      logo: getPlanLogo(planTypes.VIDEO_SDK_UC),
      trackingPlanName: this.$t('billing.video_sdk_uc.title'),
      planType: planTypes.VIDEO_SDK_UC,
    };
  },
};
